export default "__VITE_ASSET__ubKC3gb0__"